(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-subcollections"] && !Shopify.designMode) return;
  try {
    /* Shows the arrow only while there is more row to the right, and moves the
     row about one card per tap. ResizeObserver catches the row changing width
     (rotation, images loading) as well as first layout. */
  if (!customElements.get('subcollections-scroller')) {
    customElements.define(
      'subcollections-scroller',
      class extends HTMLElement {
        connectedCallback() {
          this.row = this.querySelector('.subcollections__row');
          this.arrow = this.querySelector('.subcollections__arrow');
          if (!this.row || !this.arrow) return;

          this.update = this.update.bind(this);
          this.arrow.addEventListener('click', () => this.step());
          this.row.addEventListener('scroll', this.update, { passive: true });
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.row);
          this.update();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.row?.removeEventListener('scroll', this.update);
        }

        step() {
          const card = this.row.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.row).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : this.row.clientWidth * 0.8;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.row.scrollBy({ left: distance, behavior: reduce ? 'auto' : 'smooth' });
        }

        update() {
          const { scrollLeft, scrollWidth, clientWidth } = this.row;
          const max = scrollWidth - clientWidth;
          // A couple of pixels of slack: snap points and subpixel widths leave
          // the row a fraction short of its true end.
          if (scrollLeft > 2) this.toggleAttribute('data-scrolled', true);
          this.arrow.hidden = !(max > 2 && scrollLeft < max - 2);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    // Phones: opening one neat footer accordion closes the others.
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const summary = target.closest('.menu--neat summary');
    if (!summary || !window.matchMedia('(max-width: 749px)').matches) return;
    const details = summary.parentElement;
    if (!(details instanceof HTMLDetailsElement) || details.open) return;
    const group = details.closest('accordion-custom')?.parentElement;
    group?.querySelectorAll('.menu--neat details[open]').forEach((other) => {
      if (other !== details) other.open = false;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
